export const CAMPAIGN_PROPERTIES = {
  ACTION_METADATA: 'hs_action_metadata',
  BUDGET: 'hs_budget',
  BUSINESS_UNIT_IDS: 'hs_all_assigned_business_unit_ids',
  COLOR: 'hs_color_hex',
  CREATED_AT: 'hs_created_at',
  LAST_UPDATED_AT: 'hs_lastmodifieddate',
  CREATED_BY_USER_ID: 'hs_created_by_user_id',
  GUID: 'hs_origin_asset_id',
  NAME: 'hs_name',
  NOTES: 'hs_notes',
  OBJECT_ID: 'hs_object_id',
  TEAM_IDS: 'hs_all_team_ids',
  START_DATE: 'hs_start_date',
  END_DATE: 'hs_end_date',
  OWNER: 'hs_owner',
  AUDIENCE: 'hs_audience',
  GOAL: 'hs_goal',
  GOAL_INTENTION: 'hs_goal_intention',
  GOAL_GROUP_CORRELATION_UUID: 'hs_goal_group_correlation_uuid',
  UPDATED_BY_USER_ID: 'hs_updated_by_user_id',
  UTM: 'hs_utm',
  TEMPLATE_GUID: 'hs_template_guid',
  COMMENT: 'hs_comment',
  SUPPORTS_ASSET_PLACEHOLDERS: 'hs_supports_asset_placeholders',
  STATUS: 'hs_campaign_status',
  PROMPT_INPUTS: 'hs_prompt_inputs',
  // goals-start
  SESSION_GOAL: 'hs_session_goal',
  NEW_CONTACT_GOAL: 'hs_new_contact_goal',
  INFLUENCED_CONTACT_GOAL: 'hs_influenced_contact_goal',
  INFLUENCED_CLOSED_DEAL_GOAL: 'hs_influenced_closed_deal_goal',
  INFLUENCED_REVENUE_GOAL: 'hs_influenced_revenue',
  // goals-end
  CURRENCY_CODE: 'hs_currency_code',
  BUDGET_AMOUNT: 'hs_budget_amount',
  SPEND_AMOUNT: 'hs_spend_amount',
  BUDGET_TOTAL_AMOUNT: 'hs_budget_items_sum_amount',
  SPEND_TOTAL_AMOUNT: 'hs_spend_items_sum_amount',
  PROJECTED_BUDGET: 'hs_projected_budget',
  /** Start with AI start */
  AI_FEATURES: 'hs_ai_features',
  BRIEF_PROPERTIES: 'hs_brief_properties',
  BRIEF_PROPERTIES_V2: 'hs_brief_properties_v2',
  /** End with AI end */

  /**
   * Properties defined below are used to be ignored by the filter editor
   * in Campaigns listing page.
   */
  HS_CREATE_DATE: 'hs_createdate',
  // Supposed to be a dupe from "hs_created_at". This value is always undefined!
  HS_ALL_ACCESSIBLE_TEAM_IDS: 'hs_all_accessible_team_ids',
  HS_MERGED_OBJECT_IDS: 'hs_merged_object_ids',
  HS_UNIQUE_CREATION_KEY: 'hs_unique_creation_key',
  HS_USER_IDS_OF_ALL_OWNERS: 'hs_user_ids_of_all_owners',
  /**
   * Association (rollup) properties
   */
  AD_CAMPAIGN_COUNT: 'hs_ad_campaign_count',
  AUTOMATION_PLATFORM_FLOWS_COUNT: 'hs_automation_platform_flows_count',
  BLOG_POSTS_COUNT: 'hs_blog_posts_count',
  BROADCAST_COUNT: 'hs_broadcast_count',
  CTA_COUNT: 'hs_cta_count',
  FORM_COUNT: 'hs_form_count',
  LANDING_PAGES_COUNT: 'hs_landing_pages_count',
  MARKETING_EMAILS_COUNT: 'hs_marketing_emails_count',
  SITE_PAGES_COUNT: 'hs_site_pages_count',
  /**
   * Additional HubSpot defined properties
   */
  ALL_OWNER_IDS: 'hs_all_owner_ids',
  ATTRIBUTION_ENABLED: 'hs_attribution_enabled',
  CAMPAIGN_STATUS: 'hs_campaign_status',
  HUBSPOT_OWNER_ASSIGNEDDATE: 'hubspot_owner_assigneddate',
  HUBSPOT_OWNER_ID: 'hubspot_owner_id',
  HUBSPOT_TEAM_ID: 'hubspot_team_id',
  MARKETING_EVENT_COUNT: 'hs_marketing_event_count',
  MARKETING_SMS_COUNT: 'hs_marketing_sms_count',
  OBJECT_SOURCE_ID: 'hs_object_source_id',
  OBJECT_SOURCE_USER_ID: 'hs_object_source_user_id',
  OBJECT_SOURCE: 'hs_object_source',
  ORIGIN_ASSET_UPDATED_AT: 'hs_origin_asset_updated_at',
  READ_ONLY: 'hs_read_only',
  REVENUE: 'hs_revenue',
  USER_IDS_OF_ALL_NOTIFICATION_FOLLOWERS: 'hs_user_ids_of_all_notification_followers',
  USER_IDS_OF_ALL_NOTIFICATION_UNFOLLOWERS: 'hs_user_ids_of_all_notification_unfollowers',
  WAS_IMPORTED: 'hs_was_imported',
  WEB_INTERACTIVE_COUNT: 'hs_web_interactive_count'
};